import { createFileRoute } from '@tanstack/react-router';
import RemoteImage from '~/components/RemoteImage';
// import { useStore } from '@tanstack/react-store';
// import menu from '~/data/menu';
// import { langStore } from '~/store/langStore';
import { PageSection } from './__root';

export const Route = createFileRoute('/map')({
  component: MapComponent,
});

function MapComponent() {
  // const locale = useStore(langStore, s => s);

  return (
    <PageSection>
      {/* <h1>
        {menu.menus.info.subitems["map"][locale]}
      </h1> */}
      {/* <img src="/map.webp" alt="Map" /> */}
      <RemoteImage src="/map.webp" alt="Map" className="mx-auto md:size-1/2" />

    </PageSection>
  );
}
